module.exports = __webpack_public_path__ + "img/sounds-now.d2ed39ee.png";